import axios from '../../config/axios';

export async function heartbeat() {
	await axios.get(`/api/heartbeat`);
}

export async function isSessionActive(): Promise<boolean> {
	return axios.get(`/api/auth/isSessionActive`);
}
